import { motion } from "framer-motion";

const FadeIn = ({
    children,
    delay = 0,
    triggerOnView = false,
    manualStart = false,
    start = false,
    duration = 0.75,
    className = ""
}) => {
    const variants = {
        hidden: { opacity: 0 },
        visible: { opacity: 1 },
    };

    if (manualStart) {
        return (
            <motion.div
                className={className}
                variants={variants}
                initial="hidden"
                animate={start ? "visible" : "hidden"}
                transition={{ duration, ease: "easeOut", delay }}
            >
                {children}
            </motion.div>
        );
    }

    if (triggerOnView) {
        return (
            <motion.div
                className={className}
                variants={variants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                transition={{ duration, ease: "easeOut", delay }}
            >
                {children}
            </motion.div>
        );
    }

    return (
        <motion.div
            className={className}
            variants={variants}
            initial="hidden"
            animate="visible"
            transition={{ duration, ease: "easeOut", delay }}
        >
            {children}
        </motion.div>
    );
};

export default FadeIn;
